import _ from 'underscore';

import { UAPPlacementTypeAlias as EPT } from '@bingads-webui-campaign-react/unified-ad-preview-library-cmui';

const extraPlacementInfo = {
  // MSAN
  [EPT.MSAN.WideImage]: {
    aspectRatioUIString: '1.91 : 1',
    previewStringKey: _TL_('MSN feed'),
    showAdditionalDisclaimer: true,
    disclaimerStringKey: 'ImageExperience_Additional_Disclaimer_Message',
  },
  [EPT.MSAN.MSEdgeSingleCarousel]: {
    aspectRatioUIString: '1.78 : 1',
    previewStringKey: _TL_('Microsoft edge single carousel'),
    showAdditionalDisclaimer: false,
  },
  [EPT.MSAN.MSNInArticle]: {
    aspectRatioUIString: '1.5 : 1',
    previewStringKey: _TL_('MSN in-article ad'),
    showAdditionalDisclaimer: false,
  },
  [EPT.MSAN.SquareImage]: {
    aspectRatioUIString: '1 : 1',
    previewStringKey: _TL_('MSN square image'),
    showAdditionalDisclaimer: true,
    disclaimerStringKey: 'ImageExperience_Additional_Disclaimer_Message',
  },
  [EPT.MSAN.MSNSmallHeadline]: {
    aspectRatioUIString: '1.33 : 1',
    previewStringKey: _TL_('MSN small headline'),
    showAdditionalDisclaimer: false,
  },

  // MSAN V2
  [EPT.MSANV2.MSEdgeCarousel]: {
    aspectRatioUIString: '2.01 : 1',
    previewStringKey: _TL_('Microsoft Edge carousel'),
    showAdditionalDisclaimer: false,
  },
  [EPT.MSANV2.MSANBanner]: {
    aspectRatioUIString: '2 : 1',
    previewStringKey: _TL_('MSN banner'),
    showAdditionalDisclaimer: false,
  },
  [EPT.MSANV2.MSANRiver]: {
    aspectRatioUIString: '1.91 : 1',
    previewStringKey: _TL_('MSN feed'),
    showAdditionalDisclaimer: false,
  },
  [EPT.MSANV2.MSNCarousel]: {
    aspectRatioUIString: '1.69 : 1',
    previewStringKey: _TL_('MSN carousel'),
    showAdditionalDisclaimer: false,
  },
  [EPT.MSANV2.MSNPartnerStripe]: {
    aspectRatioUIString: '1.53 : 1',
    previewStringKey: _TL_('MSN partner stripe'),
    showAdditionalDisclaimer: false,
  },
  [EPT.MSANV2.MSNRestoday]: {
    aspectRatioUIString: '1.24 : 1',
    previewStringKey: _TL_('MSN Restoday'),
    showAdditionalDisclaimer: false,
  },
  [EPT.MSANV2.MSANRectangle]: {
    aspectRatioUIString: '1.2 : 1',
    previewStringKey: _TL_('MSN rectangle image'),
    showAdditionalDisclaimer: false,
  },
  [EPT.MSANV2.MSEdgeMobile]: {
    aspectRatioUIString: '1 : 1',
    previewStringKey: _TL_('Microsoft Edge mobile'),
    showAdditionalDisclaimer: true,
    disclaimerStringKey: 'ImageExperience_Additional_Disclaimer_Message',
  },

  // MMA
  [EPT.MMA.WideImage]: {
    aspectRatioUIString: '4 : 1',
    previewStringKey: _TL_('Wide Image Multimedia Ad'),
  },
  [EPT.MMA.SquareImage]: {
    aspectRatioUIString: '1 : 1',
    previewStringKey: _TL_('Square Image Multimedia Ad'),
  },
  [EPT.MMA.VerticalImage]: {
    aspectRatioUIString: '1 : 2',
    previewStringKey: _TL_('Vertical Image Multimedia Ad'),
  },
  [EPT.MMA.LandscapeImage]: {
    aspectRatioUIString: '1.91 : 1',
    previewStringKey: _TL_('Landscape Image Multimedia Ad'),
  },
  [EPT.BingSearch.Text]: {
    aspectRatioUIString: '',
    previewStringKey: _TL_('Bing search ad'),
    showAdditionalDisclaimer: false,
  },

  // Outlook
  [EPT.Outlook.Mobile]: {
    aspectRatioUIString: '',
    previewStringKey: _TL_('Microsoft Outlook web (mobile)'),
    showAdditionalDisclaimer: false,
    isTextPlacement: true,
  },
  [EPT.Outlook.Web]: {
    aspectRatioUIString: '',
    previewStringKey: _TL_('Microsoft Outlook web (computer)'),
    showAdditionalDisclaimer: false,
    isTextPlacement: true,
  },

  // image extensions
  [EPT.ImageExt.BingDesktopSingleImage]: {
    aspectRatioUIString: '1.78 : 1',
    previewStringKey: _TL_('Bing Desktop Single-Image Extension'),
    showAdditionalDisclaimer: false,
  },
  [EPT.ImageExt.BingDesktopMultiImage]: {
    aspectRatioUIString: '1.33 : 1',
    previewStringKey: _TL_('Bing Desktop Multi-Image Extension'),
    showAdditionalDisclaimer: false,
  },
  [EPT.ImageExt.BingMobileMultiImage]: {
    aspectRatioUIString: '1.33 : 1',
    previewStringKey: _TL_('Bing Mobile Multi-Image Extension'),
    showAdditionalDisclaimer: false,
  },
  [EPT.ImageExt.WideImage]: {
    aspectRatioUIString: '1.91 : 1',
    previewStringKey: _TL_('MSN feed'),
    showAdditionalDisclaimer: true,
  },
  [EPT.ImageExt.MSEdgeSingleCarousel]: {
    aspectRatioUIString: '1.78 : 1',
    previewStringKey: _TL_('Microsoft edge single carousel'),
    showAdditionalDisclaimer: false,
  },
  [EPT.ImageExt.MSEdgeMediumHeadline]: {
    aspectRatioUIString: '1.72 : 1',
    previewStringKey: _TL_('Microsoft edge medium headline'),
    showAdditionalDisclaimer: false,
  },
  [EPT.ImageExt.MSNSingleCarousel]: {
    aspectRatioUIString: '1.69 : 1',
    previewStringKey: _TL_('MSN carousel'),
    showAdditionalDisclaimer: false,
  },
  [EPT.ImageExt.MSNMediumHeadline]: {
    aspectRatioUIString: '1.55 : 1',
    previewStringKey: _TL_('MSN medium headline'),
    showAdditionalDisclaimer: false,
  },
  [EPT.ImageExt.MSNInArticle]: {
    aspectRatioUIString: '1.5 : 1',
    previewStringKey: _TL_('MSN in-article ad'),
    showAdditionalDisclaimer: false,
  },
  [EPT.ImageExt.MSNSmallHeadline]: {
    aspectRatioUIString: '1.33 : 1',
    previewStringKey: _TL_('MSN small headline'),
    showAdditionalDisclaimer: false,
  },
  [EPT.ImageExt.SquareImage]: {
    aspectRatioUIString: '1 : 1',
    previewStringKey: _TL_('MSN square image'),
    showAdditionalDisclaimer: true,
  },
  [EPT.ImageExt.MSNDoubleCarousel]: {
    aspectRatioUIString: '0.93 : 1',
    previewStringKey: _TL_('MSN double carousel'),
    showAdditionalDisclaimer: false,
  },
  [EPT.ImageExt.MMAV2MSNRiver]: {
    aspectRatioUIString: '1.91 : 1',
    previewStringKey: _TL_('MSN feed'),
    showAdditionalDisclaimer: true,
  },
  [EPT.ImageExt.MMAV2MSNSingleCarousel]: {
    aspectRatioUIString: '1.69 : 1',
    previewStringKey: _TL_('MSN carousel'),
    showAdditionalDisclaimer: false,
  },
  [EPT.ImageExt.MSEdgeMobile]: {
    aspectRatioUIString: '1 : 1',
    previewStringKey: _TL_('Microsoft Edge mobile'),
    showAdditionalDisclaimer: true,
  },

  // pMax
  [EPT.PMax.AudienceWideImage]: {
    aspectRatioUIString: '1.91 : 1',
    previewStringKey: _TL_('MSN feed'),
    showAdditionalDisclaimer: true,
    disclaimerStringKey: 'ImageExperience_Additional_Disclaimer_Message',
  },
  [EPT.PMax.MSEdgeSingleCarousel]: {
    aspectRatioUIString: '1.78 : 1',
    previewStringKey: _TL_('Microsoft edge single carousel'),
    showAdditionalDisclaimer: false,
  },
  [EPT.PMax.MSNInArticle]: {
    aspectRatioUIString: '1.5 : 1',
    previewStringKey: _TL_('MSN in-article ad'),
    showAdditionalDisclaimer: false,
  },
  [EPT.PMax.AudienceSquareImage]: {
    aspectRatioUIString: '1 : 1',
    previewStringKey: _TL_('MSN square image'),
    showAdditionalDisclaimer: true,
    disclaimerStringKey: 'ImageExperience_Additional_Disclaimer_Message',
  },
  [EPT.PMax.MSNSmallHeadline]: {
    aspectRatioUIString: '1.33 : 1',
    previewStringKey: _TL_('MSN small headline'),
    showAdditionalDisclaimer: false,
  },
  [EPT.PMax.MMAWideImage]: {
    aspectRatioUIString: '4 : 1',
    previewStringKey: _TL_('Wide Image Multimedia Ad'),
  },
  [EPT.PMax.MMAVerticalImage]: {
    aspectRatioUIString: '1 : 2',
    previewStringKey: _TL_('Vertical Image Multimedia Ad'),
  },
  [EPT.PMax.MMALandscapeImage]: {
    aspectRatioUIString: '1.91 : 1',
    previewStringKey: _TL_('Landscape Image Multimedia Ad'),
  },
  [EPT.PMax.MMAV2MSEdgeCarousel]: {
    aspectRatioUIString: '2.01 : 1',
    previewStringKey: _TL_('Microsoft Edge carousel'),
  },
  [EPT.PMax.MMAV2MSNSingleCarousel]: {
    aspectRatioUIString: '1.69 : 1',
    previewStringKey: _TL_('MSN single carousel'),
  },
  [EPT.PMax.MMAV2MSNRestoday]: {
    aspectRatioUIString: '1.24 : 1',
    previewStringKey: _TL_('MSN restoday'),
  },
  [EPT.PMax.MMAV2MSNPartnerStripe]: {
    aspectRatioUIString: '1.53 : 1',
    previewStringKey: _TL_('MSN partner stripe'),
  },
  [EPT.PMax.MMAV2MSNRiver]: {
    aspectRatioUIString: '1.91 : 1',
    previewStringKey: _TL_('MSN feed'),
  },
  [EPT.PMax.MSEdgeMobile]: {
    aspectRatioUIString: '1 : 1',
    previewStringKey: _TL_('Microsoft Edge mobile'),
    showAdditionalDisclaimer: true,
    disclaimerStringKey: 'ImageExperience_Additional_Disclaimer_Message',
  },

  // Responsive
  [EPT.Responsive.MSAN.WideImage]: {
    aspectRatioUIString: '1.91 : 1',
    previewStringKey: _TL_('MSN feed'),
    showAdditionalDisclaimer: true,
    disclaimerStringKey: 'ImageExperience_Additional_Disclaimer_Message',
  },
  [EPT.Responsive.MSAN.MSEdgeSingleCarousel]: {
    aspectRatioUIString: '1.78 : 1',
    previewStringKey: _TL_('Microsoft edge single carousel'),
    showAdditionalDisclaimer: false,
  },
  [EPT.Responsive.MSAN.MSNInArticle]: {
    aspectRatioUIString: '1.5 : 1',
    previewStringKey: _TL_('MSN in-article ad'),
    showAdditionalDisclaimer: false,
  },
  [EPT.Responsive.MSAN.SquareImage]: {
    aspectRatioUIString: '1 : 1',
    previewStringKey: _TL_('MSN square image'),
    showAdditionalDisclaimer: true,
    disclaimerStringKey: 'ImageExperience_Additional_Disclaimer_Message',
  },
  [EPT.Responsive.MSAN.MSNSmallHeadline]: {
    aspectRatioUIString: '1.33 : 1',
    previewStringKey: _TL_('MSN small headline'),
    showAdditionalDisclaimer: false,
  },
  [EPT.Responsive.MMA.WideImage]: {
    aspectRatioUIString: '4 : 1',
    previewStringKey: _TL_('Wide Image Multimedia Ad'),
  },
  [EPT.Responsive.MMA.SquareImage]: {
    aspectRatioUIString: '1 : 1',
    previewStringKey: _TL_('Square Image Multimedia Ad'),
  },
  [EPT.Responsive.MMA.VerticalImage]: {
    aspectRatioUIString: '1 : 2',
    previewStringKey: _TL_('Vertical Image Multimedia Ad'),
  },
  [EPT.Responsive.MMA.LandscapeImage]: {
    aspectRatioUIString: '1.91 : 1',
    previewStringKey: _TL_('Landscape Image Multimedia Ad'),
  },
  [EPT.Responsive.BingSearch.Text]: {
    aspectRatioUIString: '',
    previewStringKey: _TL_('Bing search ad'),
    showAdditionalDisclaimer: false,
    isTextPlacement: true,
  },
  [EPT.Responsive.Outlook.Mobile]: {
    aspectRatioUIString: '',
    previewStringKey: _TL_('Microsoft Outlook web (mobile)'),
    showAdditionalDisclaimer: false,
    isTextPlacement: true,
  },
  [EPT.Responsive.Outlook.Web]: {
    aspectRatioUIString: '',
    previewStringKey: _TL_('Microsoft Outlook web (computer)'),
    showAdditionalDisclaimer: false,
    isTextPlacement: true,
  },
  [EPT.Responsive.PMax.MMAWideImage]: {
    aspectRatioUIString: '4 : 1',
    previewStringKey: _TL_('Wide Image Multimedia Ad'),
  },
  [EPT.Responsive.PMax.MMAVerticalImage]: {
    aspectRatioUIString: '1 : 2',
    previewStringKey: _TL_('Vertical Image Multimedia Ad'),
  },
  [EPT.Responsive.PMax.MMALandscapeImage]: {
    aspectRatioUIString: '1.91 : 1',
    previewStringKey: _TL_('Landscape Image Multimedia Ad'),
  },
  [EPT.Responsive.PMax.AudienceWideImage]: {
    aspectRatioUIString: '1.91 : 1',
    previewStringKey: _TL_('MSN feed'),
    showAdditionalDisclaimer: true,
    disclaimerStringKey: 'ImageExperience_Additional_Disclaimer_Message',
  },
  [EPT.Responsive.PMax.MSEdgeSingleCarousel]: {
    aspectRatioUIString: '1.78 : 1',
    previewStringKey: _TL_('Microsoft edge single carousel'),
    showAdditionalDisclaimer: false,
  },
  [EPT.Responsive.PMax.MSNInArticle]: {
    aspectRatioUIString: '1.5 : 1',
    previewStringKey: _TL_('MSN in-article ad'),
    showAdditionalDisclaimer: false,
  },
  [EPT.Responsive.PMax.AudienceSquareImage]: {
    aspectRatioUIString: '1 : 1',
    previewStringKey: _TL_('MSN square image'),
    showAdditionalDisclaimer: true,
    disclaimerStringKey: 'ImageExperience_Additional_Disclaimer_Message',
  },
  [EPT.Responsive.PMax.MSNSmallHeadline]: {
    aspectRatioUIString: '1.33 : 1',
    previewStringKey: _TL_('MSN small headline'),
    showAdditionalDisclaimer: false,
  },
  [EPT.Responsive.PMax.MMAV2MSEdgeCarousel]: {
    aspectRatioUIString: '2.01 : 1',
    previewStringKey: _TL_('Microsoft Edge carousel'),
  },
  [EPT.Responsive.PMax.MMAV2MSNSingleCarousel]: {
    aspectRatioUIString: '1.69 : 1',
    previewStringKey: _TL_('MSN single carousel'),
  },
  [EPT.Responsive.PMax.MMAV2MSNRestoday]: {
    aspectRatioUIString: '1.24 : 1',
    previewStringKey: _TL_('MSN restoday'),
  },
  [EPT.Responsive.PMax.MMAV2MSNPartnerStripe]: {
    aspectRatioUIString: '1.53 : 1',
    previewStringKey: _TL_('MSN partner stripe'),
  },
  [EPT.Responsive.PMax.MMAV2MSNRiver]: {
    aspectRatioUIString: '1.91 : 1',
    previewStringKey: _TL_('MSN feed'),
  },
  [EPT.Responsive.PMax.MSEdgeMobile]: {
    aspectRatioUIString: '1 : 1',
    previewStringKey: _TL_('Microsoft Edge mobile'),
    showAdditionalDisclaimer: true,
    disclaimerStringKey: 'ImageExperience_Additional_Disclaimer_Message',
  },

  // Boost
  [EPT.Boost.HeroImageCarousel200x100]: {
    aspectRatioUIString: '2 : 1',
    previewStringKey: _TL_('Hero Image Carousel'),
    isBoostPlacement: true,
  },
  [EPT.Boost.HeroImageCarousel122x100]: {
    aspectRatioUIString: '1.225 : 1',
    previewStringKey: _TL_('Hero Image Carousel'),
    isBoostPlacement: true,
  },
  [EPT.Boost.HeroImageCarousel159x100]: {
    aspectRatioUIString: '1.59 : 1',
    previewStringKey: _TL_('Hero Image Carousel'),
    isBoostPlacement: true,
  },
  [EPT.Boost.HeroImageCarousel180x100]: {
    aspectRatioUIString: '1.805 : 1',
    previewStringKey: _TL_('Hero Image Carousel'),
    isBoostPlacement: true,
  },
  [EPT.Boost.HeroImageCarousel233x100]: {
    aspectRatioUIString: '2.33 : 1',
    previewStringKey: _TL_('Hero Image Carousel'),
    isBoostPlacement: true,
  },
  [EPT.Boost.HeroImageCarousel320x100]: {
    aspectRatioUIString: '3.2 : 1',
    previewStringKey: _TL_('Hero Image Carousel'),
    isBoostPlacement: true,
  },
  [EPT.Boost.HeroImageCarousel57x100]: {
    aspectRatioUIString: '0.57 : 1',
    previewStringKey: _TL_('Hero Image Carousel'),
    isBoostPlacement: true,
  },
  [EPT.Boost.WindowsSpotlight]: {
    // aspectRatioUIString: '1.9 : 1',
    previewStringKey: _TL_('Windows Spotlight'),
    isBoostPlacement: true,
  },
  [EPT.Boost.DiscoverCard]: {
    // aspectRatioUIString: '1 : 1',
    previewStringKey: _TL_('Discover card'),
    isBoostPlacement: true,
  },
  [EPT.Boost.StartMenu]: {
    previewStringKey: _TL_('Start Menu'),
    isBoostPlacement: true,
    isTextPlacement: true,
  },
  [EPT.Boost.ActionCenter]: {
    previewStringKey: _TL_('Action Center'),
    isBoostPlacement: true,
    isTextPlacement: true,
  },
  [EPT.Boost.Banner]: {
    previewStringKey: _TL_('Banner'),
    isBoostPlacement: true,
    isTextPlacement: true,
  },
  [EPT.Boost.Prong1Prong2Feed]: {
    // aspectRatioUIString: '1.914 : 1',
    previewStringKey: _TL_('Prong 1 / Prong 2 / Feed'),
    isBoostPlacement: true,
  },
  [EPT.Boost.Coachmark]: {
    // aspectRatioUIString: '1.75 : 1',
    previewStringKey: _TL_('CoachMark'),
    isBoostPlacement: true,
  },

  // LinkedIn
  [EPT.LinkedIn.Landscape.SingleImageDesktop]: {
    previewStringKey: _TL_('Desktop feed'),
  },
  [EPT.LinkedIn.Landscape.SingleImageMobile]: {
    previewStringKey: _TL_('Mobile feed'),
  },
  [EPT.LinkedIn.Landscape.SingleImageMediumRectangle]: {
    previewStringKey: _TL_('Audience network: medium rectangle'),
  },
  [EPT.LinkedIn.Landscape.SingleImageMobileInterstitial]: {
    previewStringKey: _TL_('Audience network: mobile interstitial'),
  },
  [EPT.LinkedIn.Landscape.SingleImageNative]: {
    previewStringKey: _TL_('Audience network: native'),
  },

  [EPT.LinkedIn.Square.SingleImageDesktop]: {
    previewTitle: _TL_('Desktop feed'),
  },
  [EPT.LinkedIn.Square.SingleImageMobile]: {
    previewTitle: _TL_('Mobile feed'),
  },
  [EPT.LinkedIn.Square.SingleImageMediumRectangle]: {
    previewTitle: _TL_('Audience network: medium rectangle'),
  },
  [EPT.LinkedIn.Square.SingleImageMobileInterstitial]: {
    previewTitle: _TL_('Audience network: mobile interstitial'),
  },
  [EPT.LinkedIn.Square.SingleImageNative]: {
    previewTitle: _TL_('Audience network: native'),
  },

  [EPT.LinkedIn.Vertical.SingleImageMobile]: {
    previewTitle: _TL_('Mobile feed'),
  },
  [EPT.LinkedIn.Vertical.SingleImageMediumRectangle]: {
    previewTitle: _TL_('Audience network: medium rectangle'),
  },
  [EPT.LinkedIn.Vertical.SingleImageMobileInterstitial]: {
    previewTitle: _TL_('Audience network: mobile interstitial'),
  },
  [EPT.LinkedIn.Vertical.SingleImageNative]: {
    previewTitle: _TL_('Audience network: native'),
  },
};

export const getCurrentPlacementInfo = placementType => extraPlacementInfo[placementType];

export const getPlacementType = (adPreviewConfig, activeIndex) => {
  const { placementConfig } = adPreviewConfig;
  const placementTypesList = _.chain(placementConfig).map(({ placementTypes }) => placementTypes).flatten().value();

  return placementTypesList[activeIndex];
};

export const getPlacementTitle = (adPreviewConfig, activeIndex, i18n) => {
  const placementType = getPlacementType(adPreviewConfig, activeIndex);
  if (placementType) {
    const placementInfo = getCurrentPlacementInfo(placementType);
    if (placementInfo.aspectRatioUIString) {
      return i18n.getString('ImageExperience_Ad_Preview_Title_Template', { ratio: placementInfo.aspectRatioUIString });
    }
  }
  return i18n.getString('ImageExperience_Ad_Preview_Title');
};

export const getPlacementTitleInViewAll = (adPreviewConfig, activeIndex, i18n) => {
  const placementType = getPlacementType(adPreviewConfig, activeIndex);
  const placementInfo = getCurrentPlacementInfo(placementType);

  return (placementInfo.aspectRatioUIString && i18n.getString('ImageExperience_Ad_Preview_Ratio_Title_Template', { ratio: placementInfo.aspectRatioUIString })) || '';
};

export const normalizePreviewTexts = (previewTexts, placementType) => {
  const { isBoostPlacement } = getCurrentPlacementInfo(placementType) || {};
  const unifiedPreviewTexts = {
    finalUrl: previewTexts.finalUrl || previewTexts.url,
    ...previewTexts,
    callToAction: (isBoostPlacement && previewTexts.callToAction === 'Please select the language first')
      ? ''
      : previewTexts.callToAction,
  };
  return unifiedPreviewTexts;
};

export const AdTypeEnum = {
  MMA: 'MultimediaAd',
  MSAN: 'AudienceAd',
  MSANV2: 'AudienceAdV2',
  Boost: 'Boost',
  NewBoost: 'NewBoost',
  pMax: 'pMax',
  LinkedIn: 'LinkedIn',
};
